// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-2Vahw","label":"label-Zhu4V"};